import {
  CONTINUE_TRANSACTION,
  CONTINUE_TRANSACTION_SUCCESS,
  CONTINUE_TRANSACTION_FAILURE,
  TRANSACTION_STATUS,
  TRANSACTION_STATUS_SUCCESS,
  TRANSACTION_STATUS_VERIFY,
  TRANSACTION_STATUS_FAILURE,
  TRANSACTION_STATUS_PENDING,
  SET_RFP_MONITORING,
  SET_PARAMS,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./types";

// CONTINUE TRANSACTION SECTION
export const continueTransaction = (response) => ({
  type: CONTINUE_TRANSACTION,
  response,
});

export const continueTransactionSuccess = (response) => ({
  type: CONTINUE_TRANSACTION_SUCCESS,
  response,
});

export const continueTransactionFailure = (error) => ({
  type: CONTINUE_TRANSACTION_FAILURE,
  error,
});

// TRANSACTION STATUS SECTION
export const transactionStatus = (timestamp) => ({
  type: TRANSACTION_STATUS,
  timestamp,
});

export const transactionStatusSuccess = (response) => ({
  type: TRANSACTION_STATUS_SUCCESS,
  response,
});

export const transactionStatusVerify = (response) => ({
  type: TRANSACTION_STATUS_VERIFY,
  response,
});

export const transactionStatusFailure = (response) => ({
  type: TRANSACTION_STATUS_FAILURE,
  response,
});

export const transactionStatusPending = (response) => ({
  type: TRANSACTION_STATUS_PENDING,
  response,
});

// RFP
export const setRfpMonitoring = () => {
  return {
    type: SET_RFP_MONITORING,
  };
};

// MISCELLANEOUS
export const setParams = ({ code, merchantReturnUrl }) => {
  return {
    type: SET_PARAMS,
    code,
    merchantReturnUrl,
  }
}

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const hideLoading = () => {
  return {
    type: HIDE_LOADING,
  };
};
